import React, { useState, useMemo } from "react";
import "./App.css";
import Main from "./containers/Main";
import { ThemeProvider } from "styled-components";
import { upworkTheme, materialDarkTheme } from "./theme";
import { GlobalStyles } from "./global";

function App() {
  const [isDark, setIsDark] = useState(false);

  const theme = useMemo(() => {
    return isDark ? materialDarkTheme : upworkTheme;
  }, [isDark]);

  const handleToggle = () => setIsDark((v) => !v);

  return (
    <ThemeProvider theme={theme}>
      <>
        <GlobalStyles />
        <div>
          <Main theme={theme} isDark={isDark} onToggle={handleToggle} />
        </div>
      </>
    </ThemeProvider>
  );
}

export default App;
